/* eslint-disable import/no-cycle */
import {executePost} from '../requests';

const resourcesName = 'v1/workflow-corrections';

export const WorkflowCorrectionsApi = {
  verify: (body) => executePost(`${resourcesName}/verify`, body),
  save: (body) => executePost(`${resourcesName}/save`, body),
};
